import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { MyProjectsCustomPeriodsPageDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'

import ClockInStore from 'modules/attendance/components/ClockIn/Store'

import MyProjectsPage from './MyProjectsPage/ManagerView'

const MyProjectsCustomPeriodsPage = observer(() => {
  const { employee } = useCurrentSession()
  const { year, month, employeeId } = useParams()
  const [clockInStore, setClockInStore] = useState<ClockInStore | null>(null)

  const { loading, data } = useQuery(MyProjectsCustomPeriodsPageDocument, {
    variables: {
      employeeId: Number(employeeId),
    },
  })

  const getNewStore = (contractStartsOn: string) => {
    const coercedProps = {
      year: Number(year),
      month: Number(month),
      employeeId: Number(employeeId),
      startsOn: moment(contractStartsOn),
      currentEmployeeId: employee?.id,
    }
    return new ClockInStore(coercedProps)
  }

  useEffect(() => {
    const contractStartsOn = data?.employees.employee?.contractVersions[0]?.startsOn
    if (!loading && contractStartsOn) {
      const newStore = getNewStore(contractStartsOn)
      newStore.fetch(newStore.currentMonth)
      setClockInStore(newStore)
    }
  }, [loading])

  useEffect(() => {
    if (clockInStore) {
      clockInStore.fetch(clockInStore.currentMonth)
    }
  }, [year, month, employeeId])

  if (loading || !clockInStore) {
    return <Loading />
  }

  return <MyProjectsPage />
})

export default MyProjectsCustomPeriodsPage
